<template>
  <BRow>
    <BCol cols="4">
      <p class="font-weight-bolder text-center">نوع فایل</p>
    </BCol>
    <BCol cols="4">
      <p class="font-weight-bolder text-center">فایل</p>
    </BCol>
    <BCol cols="4">
      <p class="font-weight-bolder text-center">جزئیات</p>
    </BCol>
    <BCol cols="12" class="mt-0 px-0">
      <hr class="mt-0" />
    </BCol>
    <template v-if="attachmentList && attachmentList.length">
      <BCol
        cols="12"
        v-for="(attachment, index) in attachmentList"
        :key="attachment.id"
      >
        <BRow class="custom-inner-table-bg-color rounded-sm py-1">
          <BCol cols="4" class="px-2 mx-auto">
            <p class="text-center">
              <FeatherIcon
                :icon="attachmentTypes[attachment.resourceDetailAttachmentType]"
                size="40"
              />
            </p>
          </BCol>
          <BCol cols="4" class="px-2 mx-auto">
            <AttachmentPreviewByType
              :attachmentDetails="attachment"
            ></AttachmentPreviewByType>
          </BCol>
          <BCol
            cols="4"
            class="px-2 mx-auto d-flex align-items-center justify-content-center"
          >
            <BButton
              variant="transparent"
              size="sm"
              @click="renderDeleteAttachmentDialog(attachment)"
            >
              <FeatherIcon icon="Trash2Icon" size="25" class="text-danger" />
            </BButton>
          </BCol>
        </BRow>
        <hr v-if="!isLastAttachmentItem(index)" />
        <DeleteResourceAttachmentConfirmation
          :dialogId="attachment.id"
          :attachmentId="tempSelectedAttachmentId"
          @refetch="refetch"
        ></DeleteResourceAttachmentConfirmation>
      </BCol>
    </template>
    <template v-else>
      <BCol cols="12">
        <p class="w-100 text-center">هنوز هیچ فایلی اضافه نکرده‌اید!</p>
      </BCol>
    </template>
  </BRow>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    attachmentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      attachmentTypes: {
        1: "ImageIcon",
        2: "MusicIcon",
        3: "VideoIcon",
        4: "FileTextIcon",
        5: "ArchiveIcon",
      },
      tempSelectedAttachmentId: null,
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
    renderDeleteAttachmentDialog(attachment) {
      this.tempSelectedAttachmentId = attachment.id;
      this.$bvModal.show(`remove-single-resource-attachment-${attachment.id}`);
    },
    isLastAttachmentItem(index) {
      return index + 1 == this.attachmentList.length;
    },
  },

  components: {
    DeleteResourceAttachmentConfirmation,
    AttachmentPreviewByType,
    BRow,
    BCol,
    BButton,
  },
};
import DeleteResourceAttachmentConfirmation from "@/views/components/Resources/ResourceDetails/DeleteResourceAttachmentConfirmation.vue";
import AttachmentPreviewByType from "@/views/components/Resources/ResourceDetails/AttachmentPreviewByType.vue";
import { BRow, BCol, BButton } from "bootstrap-vue";
</script>
